import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
})
export class CheckboxComponent {

  @Input() model;
  @Input() title = "Não Informado";
  @Output() modelChange = new EventEmitter();

  constructor(){
  }
  
  setModel(model){
    this.model = model;
    this.modelChange.emit(this.model);
  } 
}
